import React from 'react';
import { BlockMath } from 'react-katex';

const Equation1 = () => {

  return (
    <div className="katex-math">
      <BlockMath math={`
        \\begin{equation}
        \\begin{bmatrix}
        b_{1} \\\\
        b_{2} \\\\
        b_{3}
        \\end{bmatrix}
        =
        \\begin{bmatrix}
        1 & 0 & 0 \\\\
        0 & \\cos(\\phi) & \\sin(\\phi) \\\\
        0 & -\\sin(\\phi) & \\cos(\\phi)
        \\end{bmatrix}
        \\begin{bmatrix}
        \\cos(\\theta) & 0 & -\\sin(\\theta) \\\\
        0 & 1 & 0 \\\\
        -\\sin(\\theta) & 0 & \\cos(\\theta)
        \\end{bmatrix}
        \\begin{bmatrix}
        \\cos(\\psi) & -\\sin(\\psi) & 0 \\\\
        \\sin(\\psi) & \\cos(\\psi) & 0 \\\\
        0 & 0 & 1
        \\end{bmatrix}
        \\end{equation}
      `} />
    </div>
  );
};

const Equation2 = () => {

  return (
    <div className="katex-math">
        <BlockMath >
           {`
           \\begin{equation}
           \\begin{bmatrix}
           b_{1} \\\\
           b_{2} \\\\
           b_{3}
           \\end{bmatrix}
           =
           \\begin{bmatrix}
           \\cos(\\theta)\\cos(\\psi) & \\cos(\\theta)\\sin(\\psi) & -\\sin(\\theta) \\\\
           -\\cos(\\phi)\\sin(\\psi)+\\cos(\\psi)\\sin(\\theta)\\sin(\\phi) & \\cos(\\psi)\\cos(\\phi)+\\sin(\\theta)\\sin(\\phi)\\sin(\\psi) & \\cos(\\theta)\\sin(\\phi)\\\\
           \\sin(\\psi)\\sin(\\theta)+\\cos(\\psi)\\cos(\\phi)\\sin(\\theta) & -\\sin(\\phi)\\cos(\\psi)+\\cos(\\phi)\\sin(\\theta)\\sin(\\psi)& \\cos(\\theta)\\cos(\\phi)
           \\end{bmatrix}
           \\begin{bmatrix}
           x \\\\
           y \\\\
           z
           \\end{bmatrix}
            \\end{equation}
           `}
        </BlockMath>
    </div>
  );
};


const Equation3 = () => {
  
    return (
      <div className="katex-math">
        <BlockMath>
            {String.raw` 
            \begin{equation}
            \begin{bmatrix}
                x \\
                y \\
                z
            \end{bmatrix}
            =
            \begin{bmatrix}
                \cos(\theta)\cos(\psi) & -\cos(\phi)\sin(\psi) + \cos(\psi)\sin(\theta)\sin(\phi) & \sin(\psi)\sin(\theta) + \cos(\psi)\cos(\phi)\sin(\theta) \\
                \cos(\theta)\sin(\psi) & \cos(\psi)\cos(\phi) + \sin(\theta)\sin(\phi)\sin(\psi) & -\sin(\phi)\cos(\psi) + \cos(\phi)\sin(\theta)\sin(\psi) \\
                -\sin(\theta) & \cos(\theta)\sin(\phi) & \cos(\theta)\cos(\phi)
            \end{bmatrix}
            \begin{bmatrix}
                b_{1} \\
                b_{2} \\
                b_{3}
            \end{bmatrix}
            \end{equation}
            `}
        </BlockMath>
      </div>
    );
  };


const Equation4 = () => {
  
    return (
      <div className="katex-math">
        <BlockMath>
            {String.raw` 
                \begin{equation}
                u(t) = K_{P}e(t) + K_{I} \int_{0}^{t} e(\tau) \, d\tau + K_{D}\frac{d e(t)}{dt}
                \end{equation}
            `}
        </BlockMath>
      </div>
    );
  };


  const Equation5 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw` 
            \begin{equation}
            \begin{bmatrix}
            F_{x} \\
            F_{y} \\
            F_{z}
            \end{bmatrix}
            =
            \begin{bmatrix}
            0 \\
            0 \\
            F_{1} + F_{2} + F_{3} + F_{4}
            \end{bmatrix}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation6 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            M_{\phi}=F_{1}d_{1y}-F_{2}d_{2y}-F_{3}d_{3y}+F_{4}d_{4y}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation7 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            M_{\theta}=-F_{1}d_{1x}-F_{2}d_{2x}+F_{3}d_{3x}+F_{4}d_{4x}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation8 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            M_{\psi}=-b(F_{1}d_{1x}d_{1y})+b(F_{2}d_{2x}d_{2y})-b(F_{3}d_{3x}d_{3y})+b(F_{4}d_{4x}d_{4y})
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation9 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            M_{\theta,\phi,\psi} = [d(F_{1}-F_{2}-F_{3}+F_{4}),d(-F_{1}-F_{2}+F_{3}+F_{4}),b(-F_{1}+F_{2}-F_{3}+F_{4})]
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };


  const Equation10 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            I
            =
            \begin{bmatrix}
            I_{xx} & -I_{yx} & -I_{zx} \\
            -I_{xy} & I_{yy} & -I_{zy} \\
            -I_{xz} & -I_{yz} & I_{zz}
            \end{bmatrix}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation11 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            I
            =
            \begin{bmatrix}
            I_{xx} & 0 & 0 \\
            0 & I_{yy} & 0 \\
            0 & 0 & I_{zz}
            \end{bmatrix}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation12 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            \begin{bmatrix}
            p  \\
            q  \\
            r 
            \end{bmatrix}
            = R_{r}
            \begin{bmatrix}
            \dot{\phi} \\
            \dot{\theta} \\
            \dot{\psi} 
            \end{bmatrix}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation13 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            R_{r}=
            \begin{bmatrix}
            1 & 0 & -\sin\theta \\
            0 & \cos\phi & \sin\phi\cos\theta \\
            0 & -\sin\phi & \cos\phi\cos\theta
            \end{bmatrix}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation14 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            I\dot{\Omega} + \Omega \times I\Omega = M_{\theta,\phi,\psi}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation15 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            \Omega = R_{r}M_{\theta,\phi,\psi}^{T}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation16 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            m\ddot{z} = mg - F
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation17 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            m\ddot{z} = \Delta F(t)
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation18 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            I_{x}\ddot{\phi}= d(-F_{1}+F_{2}+F_{3}-F_{4}) +\dot{\theta}\dot{\psi}(I_{y} - I_{z})
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation19 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            I_{y}\ddot{\theta}= d(F_{1}+F_{2}-F_{3}-F_{4}) +\dot{\phi}\dot{\psi}(I_{z} - I_{x})
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation20 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            I_{z}\ddot{\psi}= b(-F_{1}+F_{2}-F_{3}+F_{4}) +\dot{\theta}\dot{\phi}(I_{z} - I_{x})
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation21 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            \ddot{\phi}=\frac{d}{I_{x}}(-F_{1}+F_{2}+F_{3}-F_{4})
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation22 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            \ddot{\theta}=\frac{d}{I_{y}}(F_{1}+F_{2}-F_{3}-F_{4})
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation23 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            \ddot{\psi}=\frac{b}{I_{z}}(-F_{1}+F_{2}-F_{3}+F_{4})
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation24 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            \begin{bmatrix}
            \frac{F}{d}  \\
            \frac{M_{1}}{d}\\
            \frac{M_{2}}{d}\\
            \frac{M_{3}}{b}
            \end{bmatrix}
            =
            \begin{bmatrix}
            1 & 1 & 1 & 1 \\
            1 & -1 & -1 & 1 \\
            -1 & -1 & 1 & 1 \\
            -1 & 1 & -1 & 1
            \end{bmatrix}
            \begin{bmatrix}
            F_{1}  \\
            F_{2}\\
            F_{3}\\
            F_{4}
            \end{bmatrix}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation25 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            \begin{bmatrix}
            F_{1}  \\
            F_{1}\\
            F_{2}\\
            F_{3}
            \end{bmatrix}
            = \frac{1}{4}
            \begin{bmatrix}
            1 & 1 & -1 & -1 \\
            1 & -1 & -1 & 1 \\
            1 & -1 & 1 & -1 \\
            1 & 1 & 1 & 1
            \end{bmatrix}
            \begin{bmatrix}
            \frac{F}{d}  \\
            \frac{M_{1}}{d}\\
            \frac{M_{2}}{d}\\
            \frac{M_{3}}{b}
            \end{bmatrix}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation26 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            F_{i} = k_{m}\omega_{i}^{2}
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation27 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            I_{xx} \approx I_{yy} = 2 \left( m_{m}\left(\frac{d}{2}\right)^2 + (m_{h}+m_{h})\left(\frac{d}{4}\right)^2 + (m_{c}+m_{e}+m_{b})\left(\frac{d}{8}\right)^2 \right) \approx 0.009
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

  const Equation28 = () => {
    return (
      <div className="katex-math">
        <BlockMath>
          {String.raw`
            \begin{equation}
            I_{zz} = 4 \left( m_{m}\left(\frac{d}{2}\right)^2 + (m_{c}+m_{e}+m_{b})\left(\frac{d}{8}\right)^2 \right) \approx 0.015
            \end{equation}
          `}
        </BlockMath>
      </div>
    );
  };

export { Equation1, Equation2, Equation3,Equation4,Equation5,Equation6,Equation7,Equation8,Equation9,Equation10,Equation11,Equation12,Equation13,Equation14,Equation15,
  Equation16,Equation17,Equation18,Equation19,Equation20,Equation21,Equation22,Equation23,Equation24,Equation25,Equation26,Equation27,Equation28
};
